import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Marker, Popup, Tooltip, useMap } from "react-leaflet";
import { createConicGradientSVGCircleFilled, getIconMarkerCluster } from "./helper";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
// import MarkerClusterGroup from '../modules/MarkerClusterGroup'
import { useDispatch, useSelector } from "react-redux";
import { measureTextOptimized } from "../../utils/textMeasurement";
import 'react-leaflet-markercluster/styles'
import MarkerClusterGroup from "react-leaflet-markercluster";
import '../../styles/Pillars04.css'
import { setPopup } from "../../store/reducers/helpersReducer";
import { groundingIcon, pillarIcon, projectStatusOreolIcon } from "./icons";
import { renderToString } from 'react-dom/server'
import { selectPillarsWithAccountingsFiltered } from "../../store/selectors/supervisionSelector";
import { MaleRounded } from "@mui/icons-material";
import { zLayers } from "./ControlLayer";
import { selectTasksPoints } from "../../store/selectors/tasksSelector";

// Кеш для иконок кластеров, чтобы не пересобирать SVG для одинаковых распределений
const clusterIconCache = new Map();
const MAX_CLUSTER_CACHE_SIZE = 500; // Ограничение размера кэша кластеров

function recalculatePillars04TextWidth(data, size, maxWidth = null) {
    const temp = document.createElement('span');
    temp.style.font = `${size}px 'Roboto-Light', sans-serif`;
    if (maxWidth) {
        temp.style.display = 'block'
        temp.style.maxWidth = `${maxWidth}px`
        temp.style.width = `${maxWidth}px`
    } else {
        temp.style.whiteSpace = 'nowrap';
    }
    temp.style.lineHeight = '1'
    document.body.appendChild(temp);
    // const canvas = document.createElement('canvas')
    // const context = canvas.getContext('2d');
    if (data) {
        // let fntsize = window.innerWidth < 768 ? (size - 2) : size
        // context.font = `${size}px 'Roboto-Light', sans-serif` || getComputedStyle(document.body).font;
        const res = data.map(pillar => {
            let textSize = null
            let textSizeAccountingId = null
            let textSizeAccountingFull = null
            if (pillar.name) {
                temp.innerHTML = pillar.name;
                let rect = temp.getBoundingClientRect();
                textSize = { width: rect.width, height: rect.height }

                temp.innerHTML = `${pillar.name}${pillar.accounting ? ' id' + pillar.accounting.id : ''}`;
                rect = temp.getBoundingClientRect();
                textSizeAccountingId = { width: rect.width, height: rect.height }

                temp.innerHTML = `${pillar.name}${pillar.accounting ? ' id' + pillar.accounting.id + ' - ' + pillar.accounting.instructions : ''}`;
                rect = temp.getBoundingClientRect();
                textSizeAccountingFull = { width: rect.width, height: rect.height }
            }
            return {
                ...pillar,
                textSize,
                textSizeAccountingId,
                textSizeAccountingFull

            }
        })
        document.body.removeChild(temp);
        return res

    }
}

const measureText2 = (text) => {
    console.log('canvas')
    const start = new Date()
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d');
    context.font = `12px 'Roboto-Light', sans-serif` || getComputedStyle(document.body).font;
    const width = context.measureText(text).width
    const end = new Date()
    console.log('time', start.getTime(), end.getTime())
    return { width: width };
};

const measureText = (text, size, maxWidth = null) => {
    // Используем оптимизированную версию с кешированием
    return measureTextOptimized(text, size, maxWidth);
};

const checkCollisions = (hosts, map) => {
    const pillars = hosts.filter(host => host.text && host.text.size && host.text.size.width && host.text.size.height).map(host => {
        return {
            fid: host.fid,
            coords: host.coords,
            text: host.text
        }
    })
    const bounds = map.getBounds()
    const nePixel = map.project(bounds.getNorthEast());
    const swPixel = map.project(bounds.getSouthWest());

    //Формируем все возможные положения текста и расчитываем границы текста 
    const pillarsWithPossiblePositionsAndBounds = pillars.filter(h => h.text && h.text.size).map((host, index) => {
        // Проверяем что size существует и имеет нужные свойства
        if (!host.text.size || typeof host.text.size.width === 'undefined' || typeof host.text.size.height === 'undefined') {
            console.warn('Invalid text size for host:', host.fid, host.text);
            return null;
        }

        let pos = map.project(host.coords)
        let sw = { x: pos.x - host.text.size.width - 2, y: pos.y - host.text.size.height - 2 }
        let ne = { x: pos.x + host.text.size.width + 2, y: pos.y + host.text.size.height + 2 }
        let possiblepositions = []
        switch (host.text.position) {
            case 'topright':
                possiblepositions = ['topright']
                if (pos.y - host.text.size.height > nePixel.y) possiblepositions.push('bottomright')
                if (pos.x - (host.text.size.width / 2) > swPixel.x) possiblepositions.push('topleft')
                if (possiblepositions.includes('bottomright') && possiblepositions.includes('topleft')) possiblepositions.push('bottomleft')
                sw = pos
                ne = { x: pos.x + host.text.size.width + 8, y: pos.y - host.text.size.height + 2 }
                break;
            case 'topleft':
                possiblepositions = ['topleft']
                if (pos.y - host.text.size.height > nePixel.y) possiblepositions.push('bottomleft')
                if (pos.x + (host.text.size.width / 2) < nePixel.x) possiblepositions.push('topright')
                if (possiblepositions.includes('bottomleft') && possiblepositions.includes('topright')) possiblepositions.push('bottomright')
                sw = { x: pos.x - host.text.size.width - 8, y: pos.y }
                ne = { x: pos.x, y: pos.y - host.text.size.height + 2 }
                break;
            case 'bottomright':
                possiblepositions = ['bottomright']
                if (pos.y + host.text.size.height < nePixel.y) possiblepositions.push('topright')
                if (pos.x - (host.text.size.width / 2) > swPixel.x) possiblepositions.push('bottomleft')
                if (possiblepositions.includes('topright') && possiblepositions.includes('bottomleft')) possiblepositions.push('topleft')
                sw = { x: pos.x, y: pos.y + host.text.size.height }
                ne = { x: pos.x + host.text.size.width + 8, y: pos.y + 2 }
                break;
            case 'bottomleft':
                possiblepositions = ['bottomleft']
                if (pos.y + host.text.size.height < nePixel.y) possiblepositions.push('topleft')
                if (pos.x + (host.text.size.width / 2) < nePixel.x) possiblepositions.push('bottomright')
                if (possiblepositions.includes('topleft') && possiblepositions.includes('bottomright')) possiblepositions.push('topright')

                sw = { x: pos.x - host.text.size.width - 8, y: pos.y + host.text.size.height }
                ne = pos
                break;
        }

        return {
            ...host,
            bounds: new L.LatLngBounds(map.unproject(sw), map.unproject(ne)),
            possiblepositions
        }

    }).filter(item => item !== null) // Убираем null элементы

    //Распределяем пересекающиеся тексты в группы
    let intersectionGroups = []
    pillarsWithPossiblePositionsAndBounds.map((host, index) => {
        const intersects = pillarsWithPossiblePositionsAndBounds.filter((h, i) => h.bounds.intersects(host.bounds))
        if (intersects.length > 1) {
            if (!intersectionGroups.find(group => group.find(g => g.fid === intersects[0].fid))) intersectionGroups.push(intersects)
        }

    })

    //Проверка пересечений с новыми позициями
    function checkIntersection(hs) {
        // console.log(hs)
        const chosts = hs.map(host => {
            // Проверяем что size существует
            if (!host.text || !host.text.size || typeof host.text.size.width === 'undefined' || typeof host.text.size.height === 'undefined') {
                console.warn('Invalid text size in checkIntersection for host:', host.fid);
                return null;
            }

            let pos = map.project(host.coords)
            let ne = null
            let sw = null
            switch (host.position) {
                case 'topright':
                    sw = pos
                    ne = { x: pos.x + host.text.size.width + 8, y: pos.y - host.text.size.height + 2 }
                    break;
                case 'topleft':
                    sw = { x: pos.x - host.text.size.width - 8, y: pos.y }
                    ne = { x: pos.x, y: pos.y - host.text.size.height + 2 }
                    break;
                case 'bottomright':
                    sw = { x: pos.x, y: pos.y + host.text.size.height }
                    ne = { x: pos.x + host.text.size.width + 8, y: pos.y + 2 }
                    break;
                case 'bottomleft':
                    sw = { x: pos.x - host.text.size.width - 8, y: pos.y + host.text.size.height }
                    ne = pos
                    break;
            }

            return {
                ...host,
                bb: new L.LatLngBounds(map.unproject(sw), map.unproject(ne)),
            }
        }).filter(item => item !== null) // Убираем null элементы

        let isIntersects = false
        const res = chosts.map((host, index) => {
            const intersects = chosts.filter((h, i) => h.bb.intersects(host.bb))
            if (intersects.length > 1) isIntersects = true
        })
        // console.log(isIntersects)
        return isIntersects
    }

    //для каждой группы перебираем все возможные расположения текста при которых нет пересечений
    function checkAllPossiblePositions(group, index) {
        const host = group[index]
        // console.log(index)
        // console.log(host)
        // const res = host.possiblepositions.map(pos => {
        for (let i = 0; i < host.possiblepositions.length; i++) {
            // console.log(host.possiblepositions[i])
            if (index === group.length - 1) {
                const hs = [...group.slice(0, index), {
                    ...host,
                    position: host.possiblepositions[i]
                }]
                if (!checkIntersection(hs)) return hs
            } else {
                const hs = [...group.slice(0, index), {
                    ...host,
                    position: host.possiblepositions[i]
                }, ...group.slice(index + 1, group.length)]
                const tmp = checkAllPossiblePositions(hs, index + 1)
                if (tmp) return tmp
            }
        }
        return null
    }

    // console.log('start checks')
    // console.log(intersectionGroups)
    let newPositions = []
    newPositions.slice()
    for (let index = 0; index < intersectionGroups.length; index++) {

        const group = intersectionGroups[index];
        // if (group.length > 2) {
        const res = checkAllPossiblePositions(group, 0)
        // console.log(res)
        if (res && res.length) {
            newPositions = [...newPositions, ...res]
        }
        // }

    }

    // console.log(newPositions)
    return newPositions
}


export const LayerPillars = props => {
    // console.log('LayerPillars04')
    console.log(props.viewTasks)
    const map = useMap()
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });
    const clusterRef = useRef();
    const [location, setLocation] = useState(null)

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        const handleLocation = (e) => {
            console.log(e)
            setLocation(e.bounds ? {bounds: e.bounds, timestamp: e.timestamp} : null)
            
            // setLocation(e.target.value)
        };

       

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);
        map.on('locationbounds', handleLocation)

        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
            map.off('locationbounds', handleLocation)
        };
    }, [map]);

    


    // const [openedPopup, setOpenedPopup] = useState(null)
    const mounted = useSelector(
        (state) => state.state.mounted
    );

    const pillarsRedux = useSelector(selectPillarsWithAccountingsFiltered)
    const { printing, drawing } = useSelector(
        (state) => state.helper
    );


    // const mountedPillars = props.viewMounted ? (mounted.pillars || []) : []
    const pillars = useMemo(() => {
        return pillarsRedux?.filter(p => p.type === props.class) || []
    }, [pillarsRedux, props.class])



    // useEffect(() => {
    //     if (clusterRef.current) {
    //         clusterRef.current.refreshClusters();
    //     }
    // }, [pillars]);

    const createClusterCustomIcon = useCallback((cluster) => {
        if (!cluster) return null
        let type = 'default'
        if (cluster.getAllChildMarkers().find(child => child.options.status.includes('accounting'))) {
            type = 'accounting'
        }
        var types = {}

        // const t = []
        cluster.getAllChildMarkers().map(child => {

            // if (child.options.trigger > triggerMaxPriority) {
            //     triggerMaxPriority = child.options.trigger

            // } 
            const type = child.options.status === 'default' ? child.options.type : child.options.status
            if (!types[type]) types[type] = 0
            types[type] = types[type] + 1
            // t.push(child.options.status === 'default' ? child.options.type : child.options.status)
        })
        const totalCount = Object.values(types).reduce((a, v) => a + v, 0)

        // Попытка взять иконку из кеша по сигнатуре распределения типов
        const sortedEntries = Object.entries(types).sort((a, b) => a[0].localeCompare(b[0]))
        const cacheKey = `t:${type};d:${JSON.stringify(sortedEntries)}`
        if (clusterIconCache.has(cacheKey)) {
            console.log('in cache', cacheKey, clusterIconCache.size)
            return clusterIconCache.get(cacheKey)
        }

        // Очищаем кеш если он переполнен (удаляем самую старую запись)
        if (clusterIconCache.size >= MAX_CLUSTER_CACHE_SIZE) {
            const firstKey = clusterIconCache.keys().next().value;
            clusterIconCache.delete(firstKey);
        }

        const textLength = {
            1: [300, 330],
            2: [300, 330],
            3: [280, 440],
            4: [220, 480],
            5: [200, 500]
        }

        const svgIcon = ` 
            <div style='position:absolute; bottom: 0; display:flex; margin-left: 4px; margin-bottom: 4px'>

                ${Object.keys(types).length === 1 ?
                `<svg viewBox="0 0 100 100" width="20px" height="20px">
                    <circle cx="50" cy="50" r="50" fill="${`var(--${Object.keys(types)[0]})`}"/>
                </svg>`
                : createConicGradientSVGCircleFilled(Object.entries(types).map(v => ({ angle: (v[1] / totalCount) * 360, color: `var(--${v[0]})`, type: v[0] })))}
            </div>

            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -2px; margin-left: -5px'>
                <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -2px; margin-left: -6px'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="${textLength[totalCount.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[totalCount.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                    ${totalCount}
                    </text>
                </svg>
            </div>   
            `

        const icon = new L.DivIcon({
            html: svgIcon,
            className: `cluster-icon-${type}`, // чтобы убрать стандартные стили
            iconSize: [24, 24], // Размер иконки
            popupAnchor: [0, 0],
            tooltipAnchor: [-2, 0],
            iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
        });

        clusterIconCache.set(cacheKey, icon)
        return icon

        // return getIconMarkerCluster(cluster.getAllChildMarkers().length, 'pillar_' + type, t)
    }, []);

    const polygonOptions = useMemo(() => ({ color: "#grey", weight: 1 }), []);

    const handleMarkerClick = useCallback((mark) => (e) => {
        if (drawing.state && drawing.source === 'kanban' && drawing.mode === 'points') {
            map.fire('signal:kanban:pointclick', {
                mark: mark,
                _type: 'pillars'
            });
            return;
        }
        map.fire('openPopup', {
            class: 'pillar',
            mark: mark,
        });
    }, [map, drawing]);

    console.log(drawing)

    useEffect(() => {
        // preloadPillarsCommonIcons()

        return () => clearCaches()
    }, [])


    if (!pillars || pillars.length === 0) {
        return <></>
    }

    //для усечения маркеров находящихся в невидимой области
    const bounds = printing ? new L.LatLngBounds([printing.bounds.south, printing.bounds.west], [printing.bounds.north, printing.bounds.east]) : mapState.bounds
    const nePixel = map.project(bounds.getNorthEast());
    const swPixel = map.project(bounds.getSouthWest());

    //для позиционирования надписей
    // const posBounds = printing && printing.posBounds ? new L.LatLngBounds([printing.posBounds.south, printing.posBounds.west], [printing.posBounds.north, printing.posBounds.east]) : map.getBounds()
    const posnePixel = map.project(mapState.bounds.getNorthEast());
    const posswPixel = map.project(mapState.bounds.getSouthWest());

    const defaultFontSize = window.innerWidth < 768 ? 10 : 12
    let fntsize = printing ? defaultFontSize + 1 : defaultFontSize

    const pillarsInLocation = []
    // if (printing && printing.dpi) {
    //     fntsize = Math.round(fntsize * (printing.dpi / 100))
    // }

    // const displayText = displayNames && displayNames.text ? true : false
    // const displayAccounting = displayNames && displayNames.accounting ? true : false
    // const displayAccountingCompleted = displayNames && displayNames.accounting_completed ? true : false
    // const displayAccountingId = displayNames && displayNames.accountingid ? true : false

    // let hosts = filter ? pillars04Filtered.filter(host => !filter.find(f => f === parseInt(host.tp_id))) : pillars04Filtered
    // hosts = printing && printing.dpi && fntsize !== defaultFontSize ? recalculatePillars04TextWidth(hosts, fntsize) : hosts
    // const cat = props.category || '04'
    // let hosts = pillars.filter(p => p.tags.class.includes(cat))
    let hosts = pillars.map((mark, index) => {

        // let type = mark.type ? mark.type : 'pillar04'
        // //Получаем прозрачность выбранного сегмента
        // let opacity = dial.labelsOpacity[dial.selectedLabel]
        // //Если оно серое, значит выбранный тип скрывается, т.е. становится стандартным
        // if (opacity === 0) {
        //     opacity = dial.labelsOpacity[0]
        //     type = 'pillar04'
        // }

        // let opacity = 2
        //находим саму высокую прозраность среди сегментов куда вхож данный тип, кроме нулевого

        // dial.lables.map((l, i) => {
        //     if (i !== 0 && l.includes(type) && dial.labelsOpacity[i] < opacity) opacity = dial.labelsOpacity[i]
        // })


        //Если оно серое, значит выбранный тип скрывается, т.е. становится стандартным
        // if (opacity === 0) {
        //     opacity = dial.labelsOpacity[0]
        //     type = 'pillar04'
        // }

        //Если тип не относится к выбранному сегменту, то скрываем
        // if (!dial.lables[dial.selectedLabel].includes(type)) return null
        // if (cat !== mark.tags.category) return null

        const markPixel = map.project(mark.coords)
        // if (!mark.accounting) return null

        if (Number(mark.stage) === 4 && location?.bounds?.contains(new L.latLng(mark.coords[0], mark.coords[1]))) pillarsInLocation.push(mark.fid)

        //Отбрасываем маркеры которые выходят за рамки видимой области
        if ((markPixel.x < swPixel.x) || (markPixel.x > nePixel.x) || (markPixel.y < nePixel.y) || (markPixel.y > swPixel.y)) return null
        //Если идет печать то отбрасываем маркеры которые выходят за рамки заданной области
        if (printing) {
            if ((markPixel.x < posswPixel.x) || (markPixel.x > posnePixel.x) || (markPixel.y < posnePixel.y) || (markPixel.y > posswPixel.y)) return null
        }

        

        // if (mark.accounting) {
        //     switch (mark.accounting.status) {
        //         case null:
        //         case 'Не устранено':
        //             type = displayAccounting ? 'pillar04_accounting_not_completed' : 'pillar04';
        //             break;
        //         case 'Частично устранено':
        //         case 'Устранено частично':
        //             type = displayAccounting ? 'pillar04_accounting_half_completed' : 'pillar04';
        //             break;
        //         case 'Отклонено':
        //             type = displayAccounting ? 'pillar04_accounting_rejected' : 'pillar04';
        //             break;
        //         case 'Готово к проверке':
        //             type = displayAccounting ? 'pillar04_accounting_ready' : 'pillar04';
        //             break;
        //         case 'Устранено':
        //             type = displayAccountingCompleted ? 'pillar04_accounting_completed' : 'pillar04';
        //             break;

        //     }
        // }
        // if (type === 'pillar04_accounting_completed') {
        //     if (!displayAccountingCompleted) type = 'pillar04'
        // } else {
        //     if (!displayAccounting) type = 'pillar04'
        // } 

        let text = null
        let size = null
        let position = null
        let twoLineText = false

        // if ((type === 'pillar04_accounting' || type !== 'pillar04_accounting_completed') && !displayAccounting) {
        //     type = 'pillar04'
        // }
        // if (type === 'pillar04_accounting_completed' && !displayAccountingCompleted) {
        //     type = 'pillar04'
        // }
        if (mark.opacity > 0 && (mapState.zoom > 15 || printing)) {
            switch (mark.opacity) {
                case 1:
                    position = 'topright'
                    if (mark.status !== 'default') {
                        text = `${mark.name} id${mark.accounting.id}${mark.accounting.checklist ? ' ' + mark.accounting.checklist.join(',') : ''}`
                        size = mark.textSizeAccountingId
                    } else {
                        text = mark.name ? mark.name : ''
                        size = mark.textSize
                    }
                    break;
                case 2:
                    position = 'topright'
                    if (mark.status !== 'default') {
                        text = `${mark.name} id${mark.accounting.id}${mark.accounting.checklist ? ' ' + mark.accounting.checklist.join(',') : ''} - ${mark.accounting.instructions}`
                        size = mark.textSizeAccountingFull
                    } else {
                        text = mark.name ? mark.name : ''
                        size = mark.textSize
                    }
                    break;
            }

            // Если size не определен или некорректен, измеряем текст заново
            if (text && (!size || typeof size.width === 'undefined' || typeof size.height === 'undefined')) {
                // console.warn('Missing or invalid text size for mark:', mark.fid, 'measuring text:', text);
                size = measureText(text, fntsize);
            }

            if (printing && size) {
                size = { width: size.width * 1.085, height: size.height + 1 }
            }

            if (position && size && text) {
                //Если выходит за пределы справа, то перемещаем текст влево
                if ((markPixel.x + parseInt(size.width) + 20) > posnePixel.x) {
                    position = 'topleft'
                }
                //Если и слева выходит за пределы, то смотри в какой стороне больше места, перемещаем туда, и переносим текст на вторую строку
                if (position === 'topleft' && (markPixel.x - size.width - 12) < posswPixel.x) {
                    position = (markPixel.x - posswPixel.x) > (posnePixel.x - markPixel.x) ? 'topleft' : 'topright'
                    twoLineText = true
                }
                if (twoLineText) {
                    const maxWidth = position === 'topleft' ? (markPixel.x - posswPixel.x - 12) : (posnePixel.x - markPixel.x - 12)
                    size = measureText(text, fntsize, maxWidth)
                }
                if ((markPixel.y - size.height) < posnePixel.y) {
                    position = position === 'topright' ? 'bottomright' : 'bottomleft'
                }
            }
        }

        // text = mark.fid + ' ' + text




        let bounds = [[markPixel.x - 4, markPixel.y - 4], [markPixel.x + 4, markPixel.y + 4]]
        return {
            ...mark,
            text: text && size && size.width && size.height ? { text, size, position, fontSize: fntsize } : null,
            bounds,
            mount_status: [3, 4].includes(Number(mark.stage)) &&  props.viewMounted ? mark.mount_status : 0
            // mountStage: [3, 4].includes(Number(mark.stage)) &&  props.viewMounted ? mountedPillars.find(m => m.fid === mark.fid)?.mount_stage || 0 : 0
        }

    }).filter(f => f)

    if ((printing && !printing.overview && mapState.zoom > 17) || mapState.zoom >= 19) {
        // if(zoom > 17) {
        let nhosts = hosts
        for (let index = 0; index < 10; index++) {
            const newPositions = checkCollisions(nhosts, map)
            if (newPositions && newPositions.length) {
                nhosts = nhosts.map(host => {
                    const markPixel = map.project(host.coords)
                    const newpos = newPositions.find(np => np.fid === host.fid)
                    if (newpos) {
                        let size = measureText(host.text.text, host.text.fontSize)
                        const maxWidth = newpos.position.includes('left') ? (markPixel.x - posswPixel.x - 12) : (posnePixel.x - markPixel.x - 12)
                        if (maxWidth < size.width) {
                            size = measureText(host.text.text, host.text.fontSize, maxWidth)
                        }
                        return {
                            ...host,
                            text: { ...host.text, position: newpos.position, size: size }
                        }
                    }
                    return host
                })
            } else {
                break
            }

        }
        hosts = nhosts
    }


    if (location) {
        map.fire('locationpillars', {pillars: pillarsInLocation, timestamp: location.timestamp})
        setLocation(null)
    }
    



    const markers = hosts.map((mark, index) => {
        // let pos = map.project(mark.coords)
        // let ne = null
        // let sw = null
        // let bb = null
        // if (mark.text) {
        //     switch (mark.text.position) {
        //         case 'topright':
        //             sw = pos
        //             ne = { x: pos.x + mark.text.size.width + 8, y: pos.y - mark.text.size.height + 2 }
        //             break;
        //         case 'topleft':
        //             sw = { x: pos.x - mark.text.size.width - 8, y: pos.y }
        //             ne = { x: pos.x, y: pos.y - mark.text.size.height + 2 }
        //             break;
        //         case 'bottomright':
        //             sw = { x: pos.x, y: pos.y + mark.text.size.height }
        //             ne = { x: pos.x + mark.text.size.width + 8, y: pos.y + 2 }
        //             break;
        //         case 'bottomleft':
        //             sw = { x: pos.x - mark.text.size.width - 8, y: pos.y + mark.text.size.height }
        //             ne = pos
        //             break;
        //     }
        // }

        // if (ne && sw) {
        //     bb = new L.LatLngBounds(map.unproject(sw), map.unproject(ne))
        // }


        // return <Pillar04Marker mark={mark} zoom={zoom} printing={printing} map={map} openedPopup={openedPopup} setOpenedPopup={setOpenedPopup} />
        return (
            <Marker
                position={mark.coords}
                // icon={getSVGIcon(
                //     mark.type,
                //     zoom > 15 && mark.text ? mark.text : null,
                //     { ...mark.tags, status: mark.status, checklist: mark.accounting ? mark.accounting.checklist?.join(', ') : null, mountStage: mark.stage === '4' && showMounted ? mountedPillars.find(m => m.fid === mark.fid)?.mountStage || 0 : 0 }
                // )}

                icon={pillarSvgIcon(mark, mapState.zoom, props.viewProjectStatus)}
                key={printing ? 
                        `printing_${mark.fid}_${mark.status}` : 
                            drawing.state ? `drawing_${mark.fid}_${mark.status}_${drawing.mode}_${drawing.source}` : 
                            `${mark.fid}_${mark.status}`}
                data={mark.fid}
                type={mark.type}
                status={mark.status}
                // interactive={!drawing?.state || (drawing?.mode === 'points' && drawing?.source === 'kanban')}
                interactive={!drawing?.state || (drawing.state && drawing.source === 'kanban' && drawing.mode === 'points')}
                pane="pillarsPane"

                {...(printing && typeof printing === 'object' && mark.bounds && mark.coords && {
                    connected: mark.connected,
                    bounds: L.latLngBounds(map.unproject(mark.bounds[0]), map.unproject(mark.bounds[1])),
                    pos: L.latLng(mark.coords),
                    xy: mark.xy,
                    tp_id: mark.tp_id || null,
                    name: mark.name,
                    legend: 'Опора 0,4кВ'
                })}

                eventHandlers={{
                    click: handleMarkerClick(mark)
                }}

                // eventHandlers={{
                //     click: (e) => {
                //         console.log(mark)
                //         map.fire('openPopup', {
                //             class: 'pillar',
                //             mark: mark
                //         })

                //     }
                // }}


            // }}
            // window.innerWidth < 768 ?
            //     {
            //         click: (e) => {
            //             dispatch(setModal(mark))

            //         }
            //     } : {}}



            >

                {/* <Pillar04AccountingPopup
                    host={mark}
                    offset={[0, 3]}
                    prefix="Опора 0,4кВ: "
                    accountings={mark.accountings}
                    spec={mark.spec}
                    position={mark.coords}
                    mark={mark}
                /> */}
                {!drawing && <Tooltip
                    direction="top"
                    key={`${mark.fid}_tooltip`}
                    offset={[0, -5]}
                    opacity={1}

                // permanent
                >
                    {mark.text ? mark.text.text : mark.name}
                </Tooltip>}
                {/* {
                    bb ? <Rectangle
                        bounds={bb}
                    /> : null
                } */}




            </Marker>



        );
    });
    // return markers;




    return <MarkerClusterGroup
        ref={clusterRef}
        maxClusterRadius={40}
        iconCreateFunction={createClusterCustomIcon}
        removeOutsideVisibleBounds
        zoomToBoundsOnClick={true}
        spiderfyOnEveryZoom={false}
        showCoverageOnHover={false}
        animate={false}
        // animateAddingMarkers
        // animate
        type={'cluster'}
        clusterPane="pillarsPane"
        disableClusteringAtZoom={18}
        polygonOptions={polygonOptions}
        chunkedLoading={true}
        chunkInterval={200}
        chunkDelay={50}



    >
        {markers}
    </MarkerClusterGroup>
}

function getSvgIcon(mark, zoom, viewProjectStatus) {
    var svgIcon = ''
    var popupAnchor = [0, 0]
    var tooltipAnchor = [0, 0]


    if (mark.mount_status > 0) {
        svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                        <svg width="36" height="36" viewBox="0 0 100 100">
                            <defs>
                            <radialGradient id="RadialGradient1">
                                <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                                <stop offset="50%" stop-color="#00dd00" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
                            </radialGradient>
                            <radialGradient id="RadialGradient2">
                                <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                                <stop offset="50%" stop-color="#ffa000" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
                            </radialGradient>
                            </defs>
                            <circle r="50" cx="50" cy="50" fill="url(#RadialGradient${mark.mount_status === 2 ? 1 : 2})" />
                        </svg>
                    </div>
                    `
    }
    // svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 5px; margin-bottom: 5px'>
    //     ${pillarIcon(mark.type, mark.material_type, mark.supports_count, 14, 14)}
    //  </div>`

    svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 5px; margin-bottom: 5px'>
                   ${renderToString(pillarIcon(mark.type, mark.status === 'default' ? null : mark.status, mark.material_type, mark.supports_count, 14))}
                </div>
               `
    if (viewProjectStatus && [2, 3, 4, 7].includes(mark.layer)) {
        svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: -4px; margin-bottom: -4px; transform: ${mark.text?.position.includes('right') ? ' scaleX(-1)' : ''}'>
                   ${renderToString(projectStatusOreolIcon('pillar', Number(mark.layer), 32, mark.mount_status > 0 ? 5 : mark.stage))}
                </div>
               `
    }
    // svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 5px; margin-bottom: 5px'>
    //                 <svg  width="14px" height="14px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">

    //                     ${mark.supports_count === 1 ?
    //         `<circle r="40" cx="50" cy="50" fill="${mark.material_type === '1' ? 'none' : `var(--${mark.status})`}" stroke="var(--${mark.status})" stroke-width="20" />` : ''
    //     }
    //                     ${mark.supports_count === 2 ?
    //         `<rect x="10" y="10" width="80" height="80" rx="5" fill="${mark.material_type === '1' ? 'none' : `var(--${mark.status})`}" stroke="var(--${mark.status})" stroke-width="20" />` : ''
    //     }
    //                     ${mark.supports_count === 3 ?
    //         `<polygon points="50,10 90,90 10,90" fill="${mark.material_type === '1' ? 'none' : `var(--${mark.status})`}" stroke="var(--${mark.status})" stroke-width="20" />` : ''
    //     }                            
    //                 </svg>
    //             </div>
    //            `
    if (mark.status.includes('accounting') && !mark.status.includes('approved')) {
        svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: -3px; margin-bottom: -3px'>
                    <svg width="30" height="30" viewBox="0 0 100 100">
                        <circle id="ring" r="50" cx="50" cy="50" fill="var(--${mark.status})" />
                    </svg>
                </div>
                `
    }

    if (mark.grounding) {
        svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: ${mark.text && mark.text.position && mark.text.position.includes('bottomright') ? -8 : 12}px; margin-bottom: -10px'>
                    ${renderToString(groundingIcon(mark.type, 22, 22))}
                </div>`


        // svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: ${mark.text && mark.text.position && mark.text.position.includes('bottomright') ? -8 : 12}px; margin-bottom: -10px'>
        //             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="22" height="22" fill="none">
        //                 <!-- Более короткая вертикальная линия -->
        //                 <line x1="32" y1="22" x2="32" y2="36" stroke="black" stroke-width="4" stroke-linecap="round" />

        //                 <!-- Первая горизонтальная линия -->
        //                 <line x1="20" y1="36" x2="44" y2="36" stroke="black" stroke-width="4" stroke-linecap="round" />

        //                 <!-- Вторая горизонтальная линия -->
        //                 <line x1="24" y1="42" x2="40" y2="42" stroke="black" stroke-width="4" stroke-linecap="round" />

        //                 <!-- Третья горизонтальная линия -->
        //                 <line x1="28" y1="48" x2="36" y2="48" stroke="black" stroke-width="4" stroke-linecap="round" />
        //             </svg>
        //         </div>`
    }

    if (mark.text && zoom > 15) {
        let offset = 12
        let mleft = 12 + 8
        let mbottom = offset
        switch (mark.text.position) {
            case 'topleft':
                mleft = `-${mark.text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${mark.text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${mark.text.size.width - 4}`
                mbottom = `-${mark.text.size.height - offset}`
                break;
        }



        if (mark.text.size) {
            // console.log(text)
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex;  margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                <div style='color: var(--${mark.status === 'default' ? mark.type : mark.status});font-weight: normal; font-size: ${mark.text.fontSize}px; font-family: Arial, sans-serif; width: ${mark.text.size.width}px; height: ${mark.text.size.height} ; line-height: 1;
                    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                        1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${mark.text.position.includes('right') ? 'start' : 'end'}; '>
                        <span>${mark.text.text}</span>
                </div>
            </div>`
            //     svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: ${mleft}px; margin-bottom: ${mbottom}px'>
            //     <svg width="${text.size.width}" height="${text.size.height}" viewBox="0 0 ${text.size.width} ${text.size.height}">

            //         <text x="0" y="${text.fontSize}" font-size="${text.fontSize}px" style="text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
            //             1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;">
            //             <tspan fill="${colorMap[type]}">${text.text}</tspan>
            //         </text>

            //     </svg>
            // </div>`


        } else {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
            <div style='color: var(--${mark.status === 'default' ? mark.type : mark.status});font-weight: normal; font-size: ${mark.text.fontSize || 14}px; font-family: Arial, sans-serif;
                text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                    ${mark.text.text}
            </div>
        </div>`
        }



    }
    // const offs = type.includes('trans') ? -2 : -7
    const iconMarker = new L.DivIcon({
        html: svgIcon,
        className: `icon-${mark.status}`, // чтобы убрать стандартные стили
        iconSize: [24, 24], // Размер иконки
        popupAnchor: popupAnchor,
        tooltipAnchor: tooltipAnchor,
        iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
    });



    return iconMarker;


}

// Кеш для иконок - добавляем в начало файла после импортов
const iconCache = new Map();
const MAX_CACHE_SIZE = 1000;


// Функция для очистки кешей (может быть полезна для освобождения памяти)
export const clearCaches = () => {
    iconCache.clear();
    clusterIconCache.clear();
    console.log('Кеши очищены');
};

// Функция для предварительного прогрева кеша наиболее часто используемых иконок
export const preloadPillarsCommonIcons = () => {
    const commonTypes = ['pillar04']
    const commonStatuses = ['default', 'accounting_not_completed', 'accounting_completed']
    const commonStages = [0, 4]
    const commonTextPostitions = [null, 'left', 'right']
    const commonSupportsCount = [1, 2, 3]
    const commonMaterialType = [1, 2]
    const commontGroundings = [0, 1]
    const commonLayers = [null, 2, 3, 4, 7]
    const commonConfigs = [];
    commonTypes.forEach(type => {
        commonStatuses.forEach(status => {
            commonStages.forEach(stage => {
                commonTextPostitions.forEach(textPos => {
                    commonSupportsCount.forEach(supports_count => {
                        commonMaterialType.forEach(material_type => {
                            commontGroundings.forEach(grounding => {
                                commonLayers.forEach(layer => {
                                    commonConfigs.push({
                                        type,
                                        stage,
                                        status,
                                        material_type,
                                        supports_count,
                                        mount_status: 0,
                                        grounding,
                                        layer,
                                        text: textPos ? { position: textPos} : undefined
                                    });
                                })

                            });
                        });
                    });
                });
            });
        });
    });
    // Прогреваем кеш для наиболее часто используемых конфигураций (без текста)
    commonConfigs.forEach(config => {
        const mockMark = {
            ...config
        };
        const viewProjectStatus = mockMark.layer
        const cacheKey = createIconCacheKey(mockMark, 16, viewProjectStatus);
        // console.log(cacheKey)
        if (!iconCache.has(cacheKey)) {
            // Создаем базовую иконку без текста и сохраняем в кеш
            pillarSvgIcon(mockMark, 16, viewProjectStatus);
        }
    });
    console.log(`Опоры: Прогреты ${commonConfigs.length} базовых иконок в кеше`);
};

// Функция для мониторинга производительности кеша
export const getCacheStats = () => {
    return {
        iconCache: {
            size: iconCache.size,
            maxSize: MAX_CACHE_SIZE,
            hitRatio: iconCache.size > 0 ? (iconCache.size / MAX_CACHE_SIZE * 100).toFixed(1) + '%' : '0%'
        }
    };
};
// Функция для создания ключа кеша
function createIconCacheKey(mark, zoom, viewProjectStatus) {
    // Кэшируем только базовые иконки без текста
    let key = `${mark.type}_${mark.status}_${'st-' + (Number(mark.stage) === 4 ? '4' : '0')}_${'mt-' + mark.material_type}_${'sc-' + mark.supports_count}_${'ms-' + mark.mount_status}_${'g-' + mark.grounding}`
    if (mark.text) {
        key = key + `_txt-${mark.text.position.includes('right') ? 'right' : 'left'}`
    }
    if (viewProjectStatus) {
        key = key + `_ps-${mark.layer}`
    }
    return key
}


// Предварительно созданные SVG части для переиспользования
const SVG_PARTS = {
    mountStatusGradients: `
        <defs>
            <radialGradient id="RadialGradient1">
                <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                <stop offset="50%" stop-color="#ffa000" stop-opacity="0.7" />
                <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
            </radialGradient>
            <radialGradient id="RadialGradient2">
                <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                <stop offset="50%" stop-color="#00dd00" stop-opacity="0.7" />
                <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
            </radialGradient>
            <radialGradient id="RadialGradient3">
                <stop offset="0%" stop-color="#dd50dd" stop-opacity="0" />
                <stop offset="50%" stop-color="#dd50dd" stop-opacity="0.7" />
                <stop offset="100%" stop-color="#dd50dd" stop-opacity="0" />
            </radialGradient>
            <radialGradient id="RadialGradient4">
                <stop offset="0%" stop-color="#8b008b" stop-opacity="0" />
                <stop offset="50%" stop-color="#8b008b" stop-opacity="0.7" />
                <stop offset="100%" stop-color="#8b008b" stop-opacity="0" />
            </radialGradient>
        </defs>
    `,
    getMountStatusCircle: (mount_status) => `
        <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
            <svg width="36" height="36" viewBox="0 0 100 100">
                ${SVG_PARTS.mountStatusGradients}
                <circle r="50" cx="50" cy="50" fill="url(#RadialGradient${mount_status})" />
            </svg>
        </div>
    `,
    getAccountingRing: (status) => `
        <div style='position:absolute; bottom: 0; display:flex; margin-left: -3px; margin-bottom: -3px'>
            <svg width="30" height="30" viewBox="0 0 100 100">
                <circle id="ring" r="50" cx="50" cy="50" fill="var(--${status})" />
            </svg>
        </div>
    `
};

export function pillarSvgIcon(mark, zoom, viewProjectStatus) {
    // Проверяем кеш
    const cacheKey = createIconCacheKey(mark, zoom, viewProjectStatus);
    let cachedIcon = null;
    if (iconCache.has(cacheKey)) {
        cachedIcon = iconCache.get(cacheKey);
    } else {
        // console.log('not in cache', cacheKey)
        // Очищаем кеш если он переполнен
        if (iconCache.size >= MAX_CACHE_SIZE) {
            const firstKey = iconCache.keys().next().value;
            iconCache.delete(firstKey);
        }

        var svgIcon = ''
        var popupAnchor = [0, 0]
        var tooltipAnchor = [0, 0]

        // Используем предварительно созданные части
        if (mark.mount_status > 0) {
            svgIcon += SVG_PARTS.getMountStatusCircle(mark.mount_status);
        }

        svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 5px; margin-bottom: 5px'>
                       ${renderToString(pillarIcon(mark.type, mark.status, mark.material_type, mark.supports_count, 14))}
                    </div>
                   `
        if (viewProjectStatus && [2, 3, 4, 7].includes(mark.layer)) {
            svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: -4px; margin-bottom: -4px; transform: ${mark.text?.position.includes('right') ? ' scaleX(-1)' : ''}'>
                       ${renderToString(projectStatusOreolIcon('pillar', Number(mark.layer), 32, mark.stage))}
                    </div>
                   `
        }
        if (mark.status.includes('accounting') && !mark.status.includes('approved')) {
            svgIcon += SVG_PARTS.getAccountingRing(mark.status);
        }
        if (mark.grounding) {
            svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: ${mark.text && mark.text.position && mark.text.position.includes('right') ? -8 : 12}px; margin-bottom: -10px'>
                        ${renderToString(groundingIcon(mark.type, 22, 22))}
                    </div>`
        }

        const iconMarker = new L.DivIcon({
            html: svgIcon,
            className: `icon-${mark.status}`,
            iconSize: [24, 24],
            popupAnchor: popupAnchor,
            tooltipAnchor: tooltipAnchor,
            // iconAnchor: [12, 12]
        });

        // Сохраняем в кеш
        iconCache.set(cacheKey, iconMarker);
        cachedIcon = iconMarker;
    }

    // Если есть текст и нужно его добавить, создаем новую иконку с текстом
    if (mark.text && mark.text.text && zoom > 15) {
        let offset = 12
        let mleft = 12 + 8
        let mbottom = offset
        switch (mark.text.position) {
            case 'topleft':
                mleft = `-${mark.text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${mark.text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${mark.text.size.width - 4}`
                mbottom = `-${mark.text.size.height - offset}`
                break;
        }

        let textHtml = '';
        if (mark.text.size) {
            textHtml = `<div style='position:absolute; bottom: 0; display:flex;  margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                <div style='color: var(--${mark.status === 'default' ? mark.type : mark.status});font-weight: normal; font-size: ${mark.text.fontSize}px; font-family: Arial, sans-serif; width: ${mark.text.size.width}px; height: ${mark.text.size.height} ; line-height: 1;
                    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                        1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${mark.text.position.includes('right') ? 'start' : 'end'}; '>
                        <span>${mark.text.text}</span>
                </div>
            </div>`;
        } else {
            textHtml = `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
            <div style='color: var(--${mark.status === 'default' ? mark.type : mark.status});font-weight: normal; font-size: ${mark.text.fontSize || 14}px; font-family: Arial, sans-serif;
                text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                    ${mark.text.text}
            </div>
        </div>`;
        }

        // Создаем новую иконку с добавленным текстом
        const iconWithText = new L.DivIcon({
            html: cachedIcon.options.html + textHtml,
            className: cachedIcon.options.className,
            iconSize: cachedIcon.options.iconSize,
            popupAnchor: cachedIcon.options.popupAnchor,
            tooltipAnchor: cachedIcon.options.tooltipAnchor,
            iconAnchor: cachedIcon.options.iconAnchor
        });

        return iconWithText;
    }

    return cachedIcon;
}